import { useCallback, useState } from "react";

export interface CmdStatus {
    cmdInputDisabled: boolean;
    updateCmdInputValue: (value: boolean) => void;
}

export function useCmdService() {
    const [cmdInputDisabled, setCmdInputDisabled] = useState<boolean>(false);

    const updateCmdInputValue = useCallback((value: boolean) => {
        setCmdInputDisabled(value);
    }, []);

    return {
        cmdInputDisabled,
        updateCmdInputValue,
    } as CmdStatus;
}